import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LedDesign } from '../../../models/led-board.model';

export type GalleryFilter = 'all' | 'animated' | 'still';

@Component({
  selector: 'app-design-gallery',
  templateUrl: './design-gallery.component.html',
  styleUrls: ['./design-gallery.component.scss'],
  standalone: false,
})
export class DesignGalleryComponent {
  @Input() designs: LedDesign[] = [];
  @Input() sending = false;

  /** Open this design in the editor as a starting point. */
  @Output() load = new EventEmitter<LedDesign>();
  /** Put this design straight on the board, untouched. */
  @Output() send = new EventEmitter<LedDesign>();

  filter: GalleryFilter = 'all';
  selected: LedDesign | null = null;

  setFilter(f: GalleryFilter) {
    this.filter = f;
    // A design hidden by the new filter shouldn't stay selected underneath it.
    if (this.selected && !this.visible.includes(this.selected)) { this.selected = null; }
  }

  get visible(): LedDesign[] {
    if (this.filter === 'animated') { return this.designs.filter(d => this.isAnimated(d)); }
    if (this.filter === 'still') { return this.designs.filter(d => !this.isAnimated(d)); }
    return this.designs;
  }

  get animatedCount(): number { return this.designs.filter(d => this.isAnimated(d)).length; }

  isAnimated(d: LedDesign): boolean {
    return d.type === 'animation' && (d.animation?.frames?.length || 0) > 1;
  }

  frameCount(d: LedDesign): number { return d.animation?.frames?.length || 0; }

  /** What the panel says under the name. */
  summary(d: LedDesign): string {
    return this.isAnimated(d) ? `Animated, ${this.frameCount(d)} frames` : 'Still picture';
  }

  select(d: LedDesign) { this.selected = this.selected === d ? null : d; }
  close() { this.selected = null; }

  sendSelected() {
    if (!this.selected || this.sending) { return; }
    this.send.emit(this.selected);
  }

  editSelected() {
    if (!this.selected) { return; }
    this.load.emit(this.selected);
    this.close();
  }

  trackByDesign(_i: number, d: LedDesign) { return d.key || d.name; }
}
